import UserSelectionCard, { UserSelectionCardProps } from './UserSelectionCard';

export type { UserSelectionCardProps };
export default UserSelectionCard;
